export default "__VITE_ASSET__f291270b__"